
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationFlagsInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paypal_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smsNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"referral_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capital"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coin_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coins_fiat_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone_number_verified_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email_verified_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productLaunchSubscription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"individualSupport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paypal_subscription_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"package"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minCapital"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountedMonthlyPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testPhasePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annualPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountedAnnualPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyPlanId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountedMonthlyPlanId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annuallyPlanId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountedAnnuallyPlanId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentPackage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1291}};
    doc.loc.source = {"body":"mutation UpdateNotificationFlags($input: UpdateNotificationFlagsInput!) {\n    updateNotificationFlags(input: $input) {\n        id\n        name\n        surname\n        email\n        paypal_email\n        phone_number\n        emailNotification\n        smsNotification\n        referral_code\n        capital\n        coin_amount\n        coins_fiat_amount\n        phone_number_verified_at\n        email_verified_at\n        productLaunchSubscription\n        individualSupport\n        subscriptions {\n            id\n            paypal_subscription_id\n            startDate\n            endDate\n            price\n            duration\n            status\n            type\n            package {\n                id\n                name\n                description\n                type\n                minCapital\n                monthlyPrice\n                discountedMonthlyPrice\n                testPhasePrice\n                annualPrice\n                discountedAnnualPrice\n                priority\n                monthlyPlanId\n                discountedMonthlyPlanId\n                annuallyPlanId\n                discountedAnnuallyPlanId\n                parentPackage {\n                    id\n                    name\n                    description\n                }\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UpdateNotificationFlags"] = oneQuery(doc, "UpdateNotificationFlags");
        
